import { Observable } from 'rxjs'

/**
 * Interface for the 'MenuItems' data
 */
export interface MenuItemEntity {
  auction: string | null
  button_type: string
  category: string | null
  external_link: boolean
  hub: string | null
  icon: string
  icon$?: Observable<string>
  infobooth: string | null
  is_visible: boolean
  item: string | null
  item_type: string | null
  label: string
  label$?: Observable<string>
  order: number
  url: string | null
  uuid: string
}

export const LOGIN_REGISTER_CHECKIN_CHECKOUT_MENU_ITEMS = (order: number): MenuItemEntity[] => [
  {
    auction: '',
    button_type: 'event_guests',
    category: null,
    external_link: false,
    hub: null,
    icon: 'domain_verification',
    infobooth: null,
    is_visible: true,
    item: null,
    item_type: null,
    label: 'MENU_ITEM.EVENT_CHECK_IN',
    order,
    url: '',
    uuid: 'event_guests',
  },
  {
    auction: '',
    button_type: 'login',
    category: null,
    external_link: false,
    hub: null,
    icon: 'login',
    infobooth: null,
    is_visible: true,
    item: null,
    item_type: null,
    label: 'MENU_ITEM.LOG_IN',
    order,
    url: '',
    uuid: 'login',
  },
  {
    auction: '',
    button_type: 'register',
    category: null,
    external_link: false,
    hub: null,
    icon: 'how_to_reg',
    infobooth: null,
    is_visible: true,
    item: null,
    item_type: null,
    label: 'MENU_ITEM.REGISTER',
    order,
    url: '',
    uuid: 'register',
  },
  {
    auction: '',
    button_type: 'checkout',
    category: null,
    external_link: false,
    hub: null,
    icon: 'payment',
    infobooth: null,
    is_visible: true,
    item: null,
    item_type: null,
    label: 'MENU_ITEM.CHECKOUT',
    order,
    url: '',
    uuid: 'checkout',
  },
]

export enum MenuItemTypeEnum {
  TotalRaised = 'total_raised',
  InfoBooth = 'infobooth',
  MyAccount = 'my_account',
  Guests = 'guests',
  Register = 'register',
  Login = 'login',
  Checkout = 'checkout',
  SearchAndCategories = 'search_and_categories',
  AllItems = 'all_items',
  FavouriteItems = 'favourite_items',
  ActivityFeed = 'activity_feed',
  Hub = 'hub',
  Item = 'item',
  EventTicketing = 'event_ticketing',
  Category = 'category',
  ItemType = 'item_type',
  ContactOrganizer = 'contact_organizer',
  ExternalLink = 'external_link',
  EventGuests = 'event_guests',
}
